module.exports = __webpack_public_path__ + "static/media/icon-reader2.8518e761.svg";